<template>
	<div id="failed-processing-modal" class="hidden modal-new">
		<btnClose></btnClose>
		<span class="title">We couldn't process some files</span>
        <p class="description text-left">The following files couldn’t be processed</p>

        <div class="list-con">
			<div class="item-con" v-for="file in failedUploadsList" :key="file.id">
				<span>{{ file.name }}</span>
                <i v-if="isVideo(file)" class="material-icons color-warning ml-2" v-tippy content="Currently only .mp4 files are supported">error</i>
            </div>
		</div>

		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary" @click="onConfirm">
				<span>Close</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import btnClose from "@/components/app/buttons/modal/Close";
import FilenameMixin from "@/mixins/Filename";

export default {
	components: {
		btnClose,
	},

	computed: {
		...mapState("Projects", ["failedUploadsList"]),
	},

	methods: {
		onConfirm() {
			window.UI.hideModal();
			this.active = [];
			this.openBins = [];
		},

        isVideo(file) {
            let fileType = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
            return loader.unsupportedFiletypes.video.find(type => type == fileType);
        },
	},
};
</script>

<style lang="scss">
#failed-processing-modal {
	.list-con {
		margin-bottom: 30px;
	}
}
</style>
